import { render } from "./AdministerCollection.vue?vue&type=template&id=1aaae5ae"
import script from "./AdministerCollection.vue?vue&type=script&lang=js"
export * from "./AdministerCollection.vue?vue&type=script&lang=js"

import "./AdministerCollection.vue?vue&type=style&index=0&id=1aaae5ae&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__